<template>
  <div>
    <b-card bg-variant="light">
      <b-row>
        <b-col md="4">
          <storage-space-show :id="id" @gotAttrs="assignAttrs"></storage-space-show>
        </b-col>
        <b-col md="8">
          <b-tabs
            active-nav-item-class="font-weight-bold text-uppercase text-warning"
            active-tab-class="font-weight-bold text-success"
            content-class="mt-3"
            lazy
          >
            <b-tab title="Items" active>
              <div v-if="attrs">
                <product-item-index
                  :filtering="product_item_filtering"
                ></product-item-index>
              </div>
            </b-tab>
            <b-tab title="Showings">
              <div v-if="attrs">
                <showing-index
                  :filtering="showing_filtering"
                ></showing-index>
              </div>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import StorageSpaceShow from './StorageSpaceShow.vue'
import ProductItemIndex from './ProductItemIndex.vue'
import ShowingIndex from './ShowingIndex.vue'

export default {
  components: {
    StorageSpaceShow,
    ProductItemIndex,
    ShowingIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      product_item_filtering: {
        storage_space_subtree_ids: this.id
      },
      showing_filtering: {
        storage_space_path_ids: this.id
      },
      attrs: undefined
    }
  },
  methods: {
    assignAttrs(attrs) {
      this.attrs = Object.assign( {}, attrs)
    }
  },
  // mounted() {
  //   const element = document.getElementById("jump-to-header")
  //   element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  // }
}
</script>